import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ForeignKeyValidator } from 'src/app/components/core/_infrastructure/classes/foreignKeyValidator';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { TwTcTipoOrganismoNocivoViewModel } from '../../../../core/_infrastructure/types/common';
import { OrganismosNocivosService } from '../organismosnocivos.service';
import { OrganismosNocivosViewModel } from '../organismosnocivos.types';

@Component({
    selector: 'app-organismosnocivos-wrapper-edit',
    templateUrl: './organismosnocivos-wrapper-edit.component.html',
})
export class OrganismosNocivosWrapperEditComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    organismoNocivo: OrganismosNocivosViewModel;
    formGroup: FormGroup;

    messageErrorAlreadyExist = 'Ya existe este Organismo Nocivo';
    succesMessage = 'Organismo Nocivo guardado correctamente';

    listUrl = '/mantenimiento/especies/organismosnocivos';

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.getOrganismoNocivo(id);
        }
    });

    listTiposOrganismoNocivo: TwTcTipoOrganismoNocivoViewModel[];

    listTiposOrganismoNocivo$ = this.globalService.getTipoOrganismoNocivo().subscribe(params => {
        this.listTiposOrganismoNocivo = params;
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private organismosNocivosNewService: OrganismosNocivosService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        protected globalService: GlobalService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                Id: [null],
                DataType: [null, ForeignKeyValidator.cannotBeNullOrZero],
                Code: ['', Validators.required],
                CodeId: [null, Validators.required],
                Preferred: [true],
                FullName: ['', Validators.required],
                RegulatedUe: [true],
                NoEspecie: [true],
            }),
        });
    }

    private getOrganismoNocivo(id: number): void {
        this.organismosNocivosNewService
            .getOrganismoNocivo(id)
            .pipe(
                tap((v: OrganismosNocivosViewModel) => {
                    this.organismoNocivo = v;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    onSave(): void {
        this.visibilitySpinner = true;
        const model = { ...this.formGroup.value.basic };

        if (this.title == 'Editar') {
            model.Id = this.organismoNocivo.Id;
        }

        this.organismosNocivosNewService
            .saveOrganismoNocivo(model)
            .pipe(
                tap(res => {
                    this.visibilitySpinner = false;
                    this.addSuccessMessage(this.succesMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    if (error?.message?.indexOf(this.messageErrorAlreadyExist) != -1) {
                        this.formGroup.disable();
                    }
                    return of([]);
                }),
            )
            .subscribe();
    }

    get title(): string {
        return this.organismoNocivo ? 'Editar' : 'Nuevo'; // work mode: edition or creation
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    get formInvalid(): boolean {
        return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
    }
}
